import React ,{useEffect , useState} from "react";
import ExpandCollapseButton from "./expandCollapseButton";
import BackToPoolButton from "./backToPoolButton";
import TakeOverButton from "./takeOverButton";
import ReviewEntryButton from "./reviewEntry";
import FileEntryButton from "./fileEntry";
import StartJobButton from "./startJobButton";
import UpdateEntry from "./updateEntry";
import UnHoldShipmentButton from "./unHoldShipmentButton";
import HoldShipmentButton from "./holdShipmentButton";
import CancelModal from "./cancelModal";
import {Button} from "semantic-ui-react";
import {get} from "lodash";
import { useSelector } from "react-redux";
import { selectTransmissionTypeVal } from "../../components/NL_App/selectors";
import NLUpdateResponseEntry from "./NLUpdateResponseEntry";
import { getJobWheels } from "../../components/util";

function NLButtonMapper(props){
  //const dispatch = useDispatch()
    useEffect(() => {
        setTimeout(() => {
            buildButtons() 
          }, 5000);
    
      return () => {
    
      }
    }, [JSON.stringify(props.currentJobData),props.shipId])

    const [reviewedSuccessfully, setReviewSuccessfully] = useState(false);  
    const [fileWithGateway, setFileWithGateway] = useState('1');
    const [showModal, setShowModal] = useState(false);
    const [label, setLabel] = useState("");
    const [formType, setFormType] = useState("");
    const isLowerEnv = (props.lowerEnv[0] !== 'prod');
    useEffect(() => {
      //dispatch(resetServerErrors());
      setReviewSuccessfully(false)
    }, [props.shipId])
   
    const setReviewedSuccess = () => {
      setReviewSuccessfully(true)
    }
    const transmissionType=useSelector((state)=>selectTransmissionTypeVal(state))
    const {cancellationReason, reason} = useSelector((state) => state.Shipment?.exitInfo || {});
    const reasonCodes=useSelector((state) => state.DropDownValues?.reasonCodes);

    const buildButtons = () => {
      let jobWheels                  = getJobWheels(props.currentJobData);
        const EntryState             = jobWheels["ES_ENTRY_JOB_WHEEL"]?.value?.state||""
        const ESCustomState          = jobWheels["NL_CUSTOM_JOB_WHEEL"]?.value?.state||""
        const bhHouse                = jobWheels["SHIPMENT_BROKER_HOUSE_PROCESS"]?.value?.state||"";
        const is_BH_In_Process       = bhHouse === "STATE_BH_BROKER_IN_PROCESS";
        const isEntryNewJob          = EntryState.includes('NONE');
        const isEntryEditable        = EntryState.includes('IN_PROCESS') || EntryState.includes('READY');
        const isEntryInProcess       = EntryState.includes('STATE_ENTRY_IN_PROCESS');
        const isEntryFileReady       = EntryState.includes('READY');
        const isEntryReady           = EntryState.includes('STATE_ENTRY_READY');
        const isEntryFiled           = EntryState === 'STATE_ENTRY_FILED';
        const isEntryCancelFiled     = EntryState === 'STATE_ENTRY_CANCELLED_FILED';
        const isEntryCancelFailed    = EntryState === 'STATE_ENTRY_CANCELLED_FAILED';
        const isSupFiled             = EntryState === 'STATE_ENTRY_SUP_FILED';
        const isSupAccepted          = EntryState === 'STATE_ENTRY_SUP_ACCEPTED';
        const isExtFiled             = EntryState === 'STATE_ENTRY_EXT_FILED';
        const isExtAccepted          = EntryState === 'STATE_ENTRY_EXT_ACCEPTED';
        const isExtRejected          = EntryState === 'STATE_ENTRY_EXT_REJECTED';
        const isSupRejected          = EntryState === 'STATE_ENTRY_SUP_REJECTED';
        const isEntryOnHold          = EntryState === 'STATE_ENTRY_ON_HOLD';
        const isEntryRejected        = EntryState === 'STATE_ENTRY_REJECTED';  
        const isEntryAccepted        = EntryState === 'STATE_ENTRY_ACCEPTED';
        const isEntryCompleted       = EntryState === 'STATE_ENTRY_COMPLETED';
        const isEntryReleased        = EntryState === 'STATE_ENTRY_RELEASED';      
        const isEntryAmendInProcess  = EntryState.includes('STATE_ENTRY_AMEND_IN_PROCESS');
        const isEntryAmendFileReady  = EntryState.includes('STATE_ENTRY_AMEND_READY');
        const isEntryAmendFiled      = EntryState === 'STATE_ENTRY_AMEND_FILED';
        const isCancelledFiled       = EntryState === 'STATE_ENTRY_CANCELLED_FILED';
        const isCancelAccepted       = EntryState === 'STATE_ENTRY_CANCELLED';
        const isCancelledFailed      = EntryState === 'STATE_ENTRY_CANCELLED_FAILED'
        const isEntryAmendFailed     = EntryState === 'STATE_ENTRY_AMEND_FAILED'; 
        const isEntryAmendRejected   = EntryState === 'STATE_ENTRY_AMEND_REJECTED';  
        const isEntryAmendAccepted   = EntryState === 'STATE_ENTRY_AMEND_ACCEPTED';  
        const userGuid  = get(props, "kxUser.userBasicInfo.userGuid");
        const brokerGuid = get(props, "currentJobData.brokerGuid");
        let formType = EntryState.includes("AMEND") ? 'COR': 
                        EntryState.includes("SUP") ? 'SUP' :
                        EntryState.includes("EXT") ? 'EXT' :
                        EntryState.includes("CANCEL") ? 'CAN' :'DEC';

         let listOfButtons = []
         if ((bhHouse === 'STATE_BH_ASSIGNED' || bhHouse === 'STATE_BH_BROKER_ASSIGNED')) {
            listOfButtons.push(
              <StartJobButton 
                {...props} 
                EntryState={EntryState} 
                ESCustomState={ESCustomState}
                formType={formType}
                />
              );
            if(isEntryOnHold && userGuid === brokerGuid){
              listOfButtons.push(
                <UnHoldShipmentButton {...props}/>
              ); 
              return listOfButtons;
            }
            else if(isEntryOnHold && userGuid!== brokerGuid){
              listOfButtons.push(
                <TakeOverButton 
                  {...props} 
                  currentEntryState={EntryState} 
                  ESCustomState={ESCustomState}/>);
              return listOfButtons;
            }
             
            return listOfButtons;    
         }
         if(is_BH_In_Process){
            if(userGuid !== brokerGuid && (isEntryEditable || isEntryOnHold)) {
              listOfButtons.push(
                <TakeOverButton 
                  {...props} 
                  currentEntryState={EntryState} 
                  ESCustomState={ESCustomState}/>);
              return listOfButtons;
            }
            if((isEntryInProcess || isEntryFileReady) && userGuid === brokerGuid){
              listOfButtons.push(
                  <BackToPoolButton {...props}/>
                ); 
            }
            if(isEntryOnHold && userGuid === brokerGuid){
              listOfButtons.push(
                 <UnHoldShipmentButton {...props}/>
               ); 
               return listOfButtons;
            }
            if(isEntryEditable){
              if((isEntryReady || isEntryInProcess) && !reviewedSuccessfully && userGuid === brokerGuid){
                listOfButtons.push(
                   <HoldShipmentButton {...props}/>
                 ); 
              }
              if(!reviewedSuccessfully){
                listOfButtons.push(
                  <>
                    {/* <Button
                      size="mini"
                      key="XMLREVIEW"
                      disabled={false}
                      className="sv todo-button primaryBtn"
                      onClick={(e) => {
                        window.open(`broker-panel/xml-review/${props.shipId}/${formType}`, '_blank');
                      }}
                    >
                      {`XML REVIEW`}
                    </Button>  */}
                      <ReviewEntryButton 
                      setReviewSuccessfully={setReviewedSuccess} 
                      currentEntryState={EntryState}
                        {...props} 
                        formType={formType}
                      />
                    </>
                );
              }
            }
            if(isEntryFileReady && reviewedSuccessfully){
              listOfButtons.push(
                <FileEntryButton 
                  {...props}
                  label={'AGS'}
                  formType={
                    EntryState.includes("AMEND")?"COR":
                    (EntryState.includes("SUP")? "SUP": 
                    (EntryState.includes("EXT")? "EXT": "DEC"))}
                />
              );
           }
           if((isEntryCancelFiled || isEntryRejected || isEntryAmendRejected || isEntryAmendFailed || isSupRejected || isExtRejected || ((isEntryAccepted || isEntryAmendAccepted || isEntryReleased))) 
            && !['STATE_DMSEXT', 'STATE_EXT', "STATE_DMSINV", 'STATE_DMSEOG'].includes(ESCustomState)){
              let _label = (isEntryRejected || isEntryAmendRejected || isEntryCancelFailed) ? "UPDATE": null  
              let label = null;
              switch(transmissionType){
                case "COR":
                   label =  'AMEND'
                   break;
                case "SUP":
                  label =  'SUPPLIMENTARY'
                break;  
                case "EXT":
                  label =  'EXIT INFO'
                break;
                default:
                  label = _label
              }
              
              (transmissionType && label) && 
              listOfButtons.push(
              <UpdateEntry 
                {...props}
                label={label}
                transmissionType={transmissionType}
                EntryState={EntryState}
              />
            );
            if(!isEntryRejected && !isEntryAmendRejected){
              listOfButtons.push(
                <div id="sendArrival-notice-button"></div>
              );
            }
          }
          if(isEntryAmendInProcess || isEntryAmendFileReady){
            listOfButtons.push(
              <UpdateEntry 
                {...props}
                label='CANCEL AMEND'
                transmissionType={transmissionType}
                EntryState={EntryState}
              />
            );
          }
          if(isEntryFiled || isSupFiled || isEntryAmendFiled || isCancelledFiled){
            listOfButtons.push(
              <UpdateEntry 
                {...props}
                label={'RESET'}
                transmissionType={transmissionType}
                EntryState={EntryState}
              />
            )
         }

         if(isLowerEnv && (isEntryFiled || isEntryAmendFiled || isSupFiled || isExtFiled || isExtAccepted || isSupAccepted || isEntryAmendRejected || isSupRejected || isExtRejected || isCancelledFiled || isEntryAccepted || isEntryAmendAccepted || isEntryReleased)){
         // (['STATE_DMSSENT', 'STATE_CORSENT', 'STATE_EXTSENT','STATE_INVSENT', 'STATE_SUPSENT', 'STATE_SUPRCV', 'STATE_SUPREQ', 'STATE_DMSACC', 'STATE_DMSDOC', 'STATE_DMSRES', 'STATE_DMSROG', 
        // 'STATE_DMSCTL', 'STATE_DMSCLE', 'STATE_DMSRCV', 'STATE_DMSREQ', 'STATE_CORRCV', 'STATE_CORCTL', 'STATE_CORACC', 'STATE_DMSINC', 'STATE_DMSGER', 
         //'STATE_ALTREM'].includes(ESCustomState))
          listOfButtons.push(
            <> 
              <Button 
              size="mini"
              key="XMLSENT"
              disabled={false}
              className="sv todo-button secondaryBtn"
                onClick={()=>{
                  window.open(`broker-panel/xml-sent/nl/${props.shipId}`, '_blank')
                }}
              >
                VIEW XML SENT
              </Button>
            <NLUpdateResponseEntry
              propMRN={props.currentJobData.mrn}
              propDUCR={props.currentJobData.ducr}
              formType={formType}
              shipmentId={props.currentJobData.shipmentId}
              ESCustomState={ESCustomState}
              serviceType={props.serviceType}
              transmissionType={transmissionType}
              buttonTitle={"UPDATE RESPONSE"}
            />
            </>
          )
        }
          if(transmissionType === "CAN" && !isCancelAccepted){
            listOfButtons.push( 
              <Button
                  size="mini"
                  id="cancelShipment"
                  key="CANCEL_ES"
                  disabled={false}
                  className="sv todo-button primaryBtn"
                  onClick={()=>{
                      setLabel("Cancel")
                      setFormType("INV")
                      setShowModal(true)
                  }}
              >
              {"CANCEL"}
              </Button>)
          }
          if (isCancelAccepted) {
            listOfButtons.push(
              <div style={{ fontSize: '13px', color: 'crimson' }}>
                <strong>Note: </strong>No Action can be performed after Cancellation
                Accepted.
              </div>)
          }
          return listOfButtons
        }
    }


  let  workflowButtons = buildButtons() || []

    return (
            <div className="ace header-container dv-todo-isfheader">
                <ExpandCollapseButton {...props} />
                <> { 
                  showModal && 
                    <CancelModal
                      key={`cancelship-${label}`}
                      shipmentId={window.shipmentId}
                      fileWithGateway={true}
                      showModal={showModal}
                      label={label}
                      setShowModal={setShowModal}
                      formType={formType}
                      cancelReason={reason}
                      description={cancellationReason}
                      searchByID={props.searchByID}
                      options={reasonCodes}
                      lowerEnv={props.lowerEnv[0]}
                    />
                  }  {
                        window.typeOfUser !== "BROKER_KN_ADMIN" && workflowButtons.map((buttonItem,idx)=>{
                            return <div key={idx+"-workflow-btn"}>{buttonItem}</div>
                        })
                    }
                </>      
        </div>
    );
}

export default NLButtonMapper;